// extracted by mini-css-extract-plugin
module.exports = {"advisorRating":"AdvisorRating__advisorRating__+0olh","stars":"AdvisorRating__stars__GTwaW"};